export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    width: 80,
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    minWidth: 250,
    align: 'left',
    slots: { default: 'displayName' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySpecColor') || '规格颜色',
    field: 'displaySpecColor',
    minWidth: 150,
    align: 'left',
    slots: { default: 'displaySpecColor' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    minWidth: 190,
    align: 'left',
    slots: { default: 'displayNo' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayUnit') || '产品单位入数',
    field: 'displayUnit',
    minWidth: 120,
    align: 'left',
    slots: { default: 'displayUnit' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCarton') || '包装纸箱',
    field: 'displayCarton',
    minWidth: 120,
    align: 'left',
    slots: { default: 'displayCarton' },
    showHeaderOverflow: true,
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_unitQty') || '采购数量',
    field: 'unitQty',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitPrice') || '订单结算价',
    field: 'unitPrice',
    align: 'center',
    width: 120,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitAmount') || '订单结算金额',
    field: 'unitAmount',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_actualPrice') || '实际结算单价',
    field: 'actualPrice',
    align: 'center',
    width: 120,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_actualAmount') || '实际结算金额',
    field: 'actualAmount',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_amountDiff') || '结算差额',
    field: 'amountDiff',
    align: 'center',
    width: 120,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
